import { FormContainer } from '@wyz/ui';
import { useOnMount } from '@wyz/utils';
import { FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { IBaseSearchFormSchema } from '~/purchase/types';

type Props<
  T extends FieldValues & { vehicleTypeGroup: string } = IBaseSearchFormSchema,
> = {
  onSearch: (payload: Partial<{ searchQuery: T }>) => void;
  methods: UseFormReturn<T>;
  id: string;
};

function SearchFormContainer<
  T extends FieldValues & { vehicleTypeGroup: string } = IBaseSearchFormSchema,
>({ methods, onSearch, children, id }: React.PropsWithChildren<Props<T>>) {
  useOnMount(() => {
    methods.trigger('vehicleTypeGroup' as Path<T>).catch(() => {});
  });

  return (
    <FormContainer
      methods={methods as UseFormReturn<Record<string, unknown>>}
      submitHandler={(formData) => {
        onSearch({
          searchQuery: formData as T,
        });
      }}
      className='search-bar'
      id={id}
    >
      {children}
    </FormContainer>
  );
}

export default SearchFormContainer;
